import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Container,
  DropdownToggle,
  DropdownMenu, DropdownItem, UncontrolledDropdown
} from "reactstrap";
import MetaTags from "react-meta-tags";

//Import Breadcrumb
import Breadcrumbs from "../../components/common/Breadcrumb";
import "../../../src/assets/scss/custom/plugins/_datatables.scss";
import { ApiCore } from "../../helpers/api_helper";
import { Loading } from "../../components/common/Loading";
import { AxiosResponse } from "axios";
import XModal from "../../components/common/XModal";
import { Endpoints } from "../../utils/Endpoints";
import BulkUpload from "./upload";
import Logo from "../../assets/images/logo.png"
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { can, formattedDate } from "../../utils/Helpers";
import CreateForm from "../../components/forms/CreateForm";
import { CalendarFields } from "../../fields/CalendarFields";

const Calendars = () => {

  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [calendars, setCalendars] = useState<any>([]);
  const [showCalendarDialog, setShowCalendarDialog] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({});

  const request = new ApiCore();

  useEffect(() => {
    searchCalendars({})
  }, []);

  const searchCalendars = (values: any) => {
    values.per_page = 1000;
    request
      .get(Endpoints.calendars, { params: values }, values.excel && values.excel == 1 ? "arraybuffer" : "json").then((response: AxiosResponse) => {
        setCalendars(response.data);
        setLoading(false);
      });
  }

  const handleBulkUpload = (values: any) => {
    setSaving(true)
    const responseType = "arraybuffer";
    request.createFormData(Endpoints.calendars, values, responseType).then((response: AxiosResponse) => {
      setSaving(false);
      setShowCalendarDialog(false);
      searchCalendars({});
    }).catch((error) => {
      setSaving(false);
      toast.error(error);
    });
  }

  const handleAction = (item: any, action: string) => {
    if (action == "delete") {
      if (window.confirm("Do you want to delete this record?")) {
        request.delete(Endpoints.calendars + "/" + item.id).then((response: AxiosResponse) => {
          window.location.reload();
        }).catch((error) => {
          setSaving(false);
          toast.error(error);
        });
      }
    } else {
      setInitialValues(item);
      setShowCalendarDialog(true)
    }
  };

  const handleUpdate = (item: any) => {

  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Calendar</title>
        </MetaTags>

        <Container fluid>
          <Breadcrumbs title="Calendars" breadcrumbItem="List" />

          <XModal title={"Create calendar"}
            width={"lg"}
            open={showCalendarDialog}
            toggle={() => setShowCalendarDialog(!showCalendarDialog)}
            onClose={() => setShowCalendarDialog(false)}>


            <CreateForm
              fields={CalendarFields}
              initialValues={initialValues}
              submitEndpoint={initialValues.id ? Endpoints.calendars + "/" + initialValues.id : Endpoints.calendars}
              submitButtonLabel={initialValues.id ? "Edit Calendar" : "Add Calendar"}
              debug={false}
              handleUpdate={handleUpdate}
              onClose={() => setShowCalendarDialog(false)} />

          </XModal>

          <Row>
            <Col md={12} lg={12} xl={12}>
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <CardTitle className="h4">
                    Calendar
                  </CardTitle>

                  <UncontrolledDropdown className="mt-4 mt-sm-0">
                    <DropdownToggle tag="a" className="btn btn-light">
                      <i className="fa fa-ellipsis-v"></i>
                    </DropdownToggle>

                    <DropdownMenu className="dropdown-menu-end">
                      <>
                        {can("manage", "Calendar") &&
                          <DropdownItem to="#" onClick={() => { setInitialValues({}); setShowCalendarDialog(true) }}>
                            Add Calendar
                          </DropdownItem>
                        }
                      </>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  {loading && <Loading label="Loading calendars. Please wait." />}
                  {!loading &&
                    <Row>
                      {calendars.map((calendar: any) => {
                        return (
                          <Col md={4}>
                            <Card>
                              <img src={calendar.coverUrl} className="card-img-top" />
                              <CardBody>
                                <Row>
                                  <Col md={2}>
                                    <img src={Logo} className="img-round" />
                                  </Col>
                                  <Col>
                                    <p><h5 className="card-title">{calendar.title}</h5></p>
                                    <p className="txt-caption">
                                      <b>Term:</b> {calendar.term} - {calendar.year}<br />
                                      <b>Class:</b> {calendar.form} ({calendar.campus})<br />
                                      <b>Starts at:</b> {formattedDate(calendar.start_date_time)}
                                    </p>
                                    <p>{calendar.details}</p>
                                    {can("manage", "Calendar") &&
                                      <p>
                                        <a href="#" onClick={() => handleAction(calendar, "edit")}><i className="fa fa-edit"></i> Edit</a>
                                        &nbsp;|&nbsp;
                                        <a href="#" onClick={() => handleAction(calendar, "delete")} className="red"><i className="fa fa-trash red"></i> Delete</a>
                                      </p>
                                    }
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        )
                      })}
                    </Row>
                  }

                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>

      </div>
    </React.Fragment>
  );
};

export default Calendars;